export default "__VITE_ASSET__60e3563a__"